import { Button, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const BudgetSuccessModal = ({ open, onClose, budgetName }) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        width="415px"
        title={false}
        open={open}
        onOk={onClose}
        onCancel={onClose}
        className="custom-common-modal"
        centered
        closeIcon={false}
        footer={false}
      >
        <div className="row modal-main-inner-row">
          <div className="col-12 text-center">
            <img
              src="/assets/images/icons/budget_icon.svg"
              className="img-fluid"
              alt=""
            />
            <h1 className="mb-3">{t("dashboard.savedBudget.title")}</h1>
            <p>{t("dashboard.savedBudget.desc", { budgetName: budgetName })}</p>

            <div className="row modal-footer-row">
              <div className="col-12 ">
                <Button type="primary " onClick={onClose}>
                  {t("dashboard.savedBudget.btnTxt")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BudgetSuccessModal;
